<template>

<v-layout>
    <v-flex class="headline">
        <v-card color="accent" :max-height="100" class="header-card card-header">
            <v-card-title class="headline" style="color: #444;">
                <v-layout>
                    <v-flex>
                        {{this.headerText}}
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card>
    </v-flex>
</v-layout>

</template>
<script>
export default {
    data() {
        return {
            varosLista: [],
        };
    },

    props: {
        headerText: {
            type: String,
            required: true,
        },
    },
};
</script>
<style scoped>

.header-card {
    top: -30px !important;
    margin: 0 auto;
    color: white;
    font-size: 10px;
}
.card-header{
    transition: all ease-in-out 0.3s;
}
</style>
